import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

// attach token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ge_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// American odds formatter
export const fmtOdds = (o) => (o > 0 ? `+${o}` : `${o}`);
export const fmtPct = (v, d = 1) => `${(v * 100).toFixed(d)}%`;
export const fmtSigned = (v, d = 1) => `${v >= 0 ? "+" : ""}${v.toFixed(d)}`;
export const fmtMoney = (v) => {
  const abs = Math.abs(v);
  return (v < 0 ? "-$" : "$") + abs.toFixed(2);
};
